// Página pública dos termos de uso e da política de privacidade (0.46), aberta sem entrar na conta:
// myplanner.expo.app/privacidade e myplanner.expo.app/termos (o Google pede esses links para publicar o acesso ao Drive).
import { Pressable, ScrollView, Text, View } from 'react-native';
import { TextoLegal } from './Termos';
import { CONTATO_PRIVACIDADE } from '../lib/termos';
import { C } from './theme';
import { t } from '../lib/i18n';

export function PaginaLegal() {
  const cor = '#8B5CF6';
  return (
    <ScrollView style={{ flex: 1, backgroundColor: C.bg }} contentContainerStyle={{ padding: 20, paddingBottom: 60, alignItems: 'center' }}>
      <View style={{ width: '100%', maxWidth: 760, gap: 16 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
          <Text style={{ fontSize: 30 }}>📅</Text>
          <Text style={{ color: C.text, fontSize: 24, fontWeight: '800', flex: 1 }}>My Planner Anne</Text>
          <Pressable onPress={() => { window.location.href = '/'; }} style={{ backgroundColor: cor, borderRadius: 12, paddingHorizontal: 14, paddingVertical: 9 }}>
            <Text style={{ color: '#fff', fontWeight: '700' }}>{t('Abrir o app')}</Text>
          </Pressable>
        </View>
        {/^\/excluir-conta/i.test(window.location.pathname) ? <ExcluirConta cor={cor} /> : <TextoLegal cor={cor} />}
      </View>
    </ScrollView>
  );
}

/** myplanner.expo.app/excluir-conta (0.54): como apagar a conta e os dados (a Google Play e a Apple pedem este link). */
function ExcluirConta({ cor }: { cor: string }) {
  const P = ({ children }: { children: string }) => <Text style={{ color: C.sub, fontSize: 15, lineHeight: 22 }}>{children}</Text>;
  return (
    <View style={{ gap: 12 }}>
      <Text style={{ color: C.text, fontSize: 20, fontWeight: '800' }}>{t('Como apagar a sua conta e os seus dados')}</Text>
      <P>{t('Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:')}</P>
      <P>{'1. ' + t('Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.')}</P>
      <P>{'2. ' + t('Toque em Ajustes e depois em Segurança.')}</P>
      <P>{'3. ' + t('Toque em "Apagar minha conta e todos os dados" e confirme.')}</P>
      <Text style={{ color: C.text, fontSize: 17, fontWeight: '800', marginTop: 6 }}>{t('O que é apagado')}</Text>
      <P>{t('A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.')}</P>
      <P>{t('Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.')}</P>
      <Text style={{ color: C.text, fontSize: 17, fontWeight: '800', marginTop: 6 }}>{t('Não consegue entrar?')}</Text>
      <P>{t('Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.')}</P>
      <Pressable onPress={() => { window.location.href = `mailto:${CONTATO_PRIVACIDADE}?subject=${encodeURIComponent(t('Apagar minha conta'))}`; }}>
        <Text style={{ color: cor, fontSize: 16, fontWeight: '700' }}>{CONTATO_PRIVACIDADE}</Text>
      </Pressable>
    </View>
  );
}
